module.exports = __webpack_public_path__ + "img/exams.6ce56d8b.jpeg";